// extracted by mini-css-extract-plugin
module.exports = {"load-more-button":"LoadMoreButton_load-more-button__FZArM","load-more-button--text":"LoadMoreButton_load-more-button--text__ECIIH"};